import { createSelector } from '@ngrx/store';
import { getLocationDetails } from '../getLocationDetails';
import * as Utils from '@shared/core/utils';
import { MILE_IN_KILOMETERS } from '@shared/core/consts';

export const isLocationInDeliveryRadius = (locationNo: number, deliveryAddress: APICommon.DeliveryDetailsBusinessModelExtended) =>
    createSelector(getLocationDetails(locationNo), (locationDetails) => {
        if (!locationDetails?.DeliveryRadius || !deliveryAddress?.Latitude || !deliveryAddress?.Longitude || !locationDetails?.Latitude || !locationDetails?.Longitude) {
            return false;
        }
        const isMetric = locationDetails.DeliveryRadiusUnitType === 1;

        let distance = Utils.Geolocation.getDistanceFromTo(
            {
                latitude: deliveryAddress.Latitude,
                longitude: deliveryAddress.Longitude,
            },
            {
                latitude: locationDetails.Latitude,
                longitude: locationDetails.Longitude,
            },
        );
        distance = isMetric ? distance : distance / MILE_IN_KILOMETERS;

        if (distance <= locationDetails.DeliveryRadius) {
            return true;
        }

        return false;
    });
